import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { team } from '../mock';

const TeamPreview = () => {
  const preview = team.slice(0, 4);
  return (
    <section className="py-16 lg:py-24 bg-white">
      <div className="max-w-[1240px] mx-auto px-6">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-10">
          <div>
            <span className="text-[12px] font-semibold tracking-[0.2em] text-neutral-500 uppercase">Our Team</span>
            <h2 className="mt-3 text-[36px] lg:text-[48px] leading-[1.02] font-bold tracking-tight text-neutral-900">
              People who <span className="font-serif-italic font-normal">listen first.</span>
            </h2>
          </div>
          <Link to="/team" className="inline-flex items-center gap-1 text-[14px] font-medium text-[#CA0028] group">
            View All Therapists
            <ArrowRight size={14} className="group-hover:translate-x-1 transition-transform" />
          </Link>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-5">
          {preview.map((m) => (
            <Link key={m.slug} to={`/team/${m.slug}`} className="group">
              <div className="rounded-[20px] overflow-hidden aspect-[4/5] bg-neutral-100">
                <img src={m.photo} alt={m.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" style={{ objectPosition: m.photoPosition || 'center center', transform: m.photoScale ? `scale(${m.photoScale})` : undefined }} loading="lazy" />
              </div>
              <h3 className="mt-4 text-[16px] font-semibold text-neutral-900 group-hover:text-[#CA0028] transition-colors">{m.name}</h3>
              <p className="text-[13px] text-neutral-500">{m.role}</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TeamPreview;
